/**
 * Определяет, запущено ли приложение в Telegram-контексте
 *
 * Проверяет наличие TelegramWebviewProxy (native app) или iframe (Telegram Web)
 *
 * @returns {boolean} true если приложение открыто в Telegram
 */
export const isTelegram = (): boolean => {
  const hash = window.location.hash || ''
  return (
    !!(window as unknown as Record<string, unknown>).TelegramWebviewProxy ||
    window !== window.parent ||
    hash.includes('tgWebAppData') ||
    hash.includes('tgWebAppPlatform')
  )
}
